<template>
  <div class="h-full">
    <div
      v-if="!showTeamMemberList"
      class="relative pb-2 h-full"
    >
      <section class="share__presentation-online-link">
        <p class="share__section-description" v-if="!hideTitle">
          {{ $i18nPresenter.t(`To let others edit this presentation with you,` + ' ' +
            `please enter their email addresses here:`) }}
        </p>
        <div
          class="flex gap-2 items-center p-2 bg-yellow-10 mb-4 rounded"
          v-if="showViewerCannot"
        >
          <span><img alt="giphy-star-icon" :src="require('@/assets/images/icon/warning-circle.svg')"></span>
          {{ $i18nPresenter.t(`You’re a viewer, so you can’t add collaborators.`) }}
        </div>
        <form
          class="flex items-center mb-2"
          @submit.prevent="onSubmit()"
        >
          <div class="mr-2 share-input-tag-wrp items-center">
            <AhaInputTagObject
              id="input-tag__share-to-edit"
              ref="collaborators-input"
              class=""
              v-model="emails"
              :allow-duplicate="false"
              :placeholder="emails.length > 0 ? '' : inputTagPlaceHolder"
              :validator="emailRegex"
              :formatter="(entry) => entry.toLowerCase()"
              :teams="canViewerShare ? teams : []"
              :disabled="!canViewerShare"
            >
              <template #roleselection>
                <RoleSelection
                  :style="{
                    width: '75px',
                    height: 'calc(100% - 3px)',
                    overflow: 'hidden'
                  }"
                  :invitedRole="invitedRole"
                  @changeInvitedRole="changeInvitedRole"
                  :hideRoleAdmin="true"
                  :disabled="!canViewerShare"
                />
              </template>
            </AhaInputTagObject>
          </div>

          <vue-recaptcha
            v-if="!isZoomReady"
            :sitekey="keyRecaptcha"
            @verify="onVerify"
            @error="onRecaptchaError"
            size="invisible"
            @expired="onExpired"
            :load-recaptcha-script="true"
            recaptcha-host="www.recaptcha.net"
            ref="recaptcha"
            class="auth-captcha"
          />

          <aha-antd-button
            v-aha-emit-action
            name="add-collaborator-button"
            type="submit"
            class="py-2"
            ref="shareToEditButton"
            isLoadingInline
            :submitting="submitting"
            :disabled="!canAddCollaborator"
          >
            <span>{{ $i18nPresenter.t('Add') }}</span>
          </aha-antd-button>
        </form>
      </section>

      <PresentationCollaborateList
        :folder="folder"
        :presentation="presentation"
        :collaborators="collaborators"
        :teamCollaborators="teamCollaborators"
        :isDisableEditPresentation="isDisableEditPresentation"
        @handleRemoveCollaborator="handleRemoveCollaborator"
        @handleChangeCollaboratorRole="handleChangeCollaboratorRole"
        :loadingCollaborators="loadingCollaborators"
      />
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

import { mapState, mapGetters, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import configs from '@/config'

import Utils from '@/util'
import FolderApi from '@/api/folder'
import PresentationApi from '@/api/presentation'
import PresentationCollaborateList from '@/components-v2/presentation-editor/collaboration/PresentationCollaborateList.vue'
import constants from '@/constant'
import EventBus from '@/eventBus'
import RoleSelection from '@/components-v2/my-team/RoleSelection.vue'

const { eventCategories } = constants
// components

export default {
  components: {
    PresentationCollaborateList,
    VueRecaptcha,
    RoleSelection,
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    folder: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    hasPadding: {
      type: Boolean,
      default: false,
    },
    shareTeam: {
      type: Boolean,
      default: true,
    },
    invitedRole: {
      type: String,
      default: constants.role.EDITOR,
    },
  },
  data() {
    return {
      keyRecaptcha: configs.keyRecapcha,
      tokenRecaptcha: '',
      submitting: false,
      textError: '',
      showTeamMemberList: false,
      emails: [],
      collaborators: [],
      teamCollaborators: [],
      loadingCollaborators: false,
      isSendingInvitations: false,
      emailRegex: "^(([^<>()[\\]\\.,;:\\s@']+(\\.[^<>()[\\]\\.,;:\\s@']+)*)|('.+'))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$",
      teams: [],
      permissions: constants.permissions,
      // invitedRole: constants.role.EDITOR,
    }
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      canViewerShare: (state) => state.canViewerShare,
    }),
    hasTeam() {
      return this.currentAccount && this.currentAccount.id
    },
    isNotSkoletube() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },
    sendACopyVisible() {
      return this.hasTeam && this.isNotSkoletube && this.shareTeam
    },
    inputTagPlaceHolder() {
      return this.$i18nPresenter.t('Enter emails, comma separated')
    },
    canAddCollaborator() {
      if (this.folder) {
        // return this.folder.ownerId === this.currentUser.id ||
        return this.folder.ownerId === this.currentUser.id ||
          (this.folder.permissions && this.folder.permissions.includes(this.permissions.INVITE_TO_EDIT))
      }
      // return this.presentation.ownerId === this.currentUser.id ||
      // return this.presentation.userId === this.currentUser.id ||
      return (this.presentation.permissions &&
        this.presentation.permissions.includes(this.permissions.INVITE_TO_EDIT)) &&
        this.emails.length > 0
    },
    showViewerCannot() {
      if (this.presentation) {
        // if (this.presentation.userId === this.currentUser.id) {
        //   return false
        // }
        return !this.presentation.permissions.includes(constants.permissions.RENAME_PRESENTATION)
      }
      if (this.folder.ownerId === this.currentUser.id) {
        return false
      }
      return !this.folder.permissions.includes(constants.permissions.RENAME_PRESENTATION)
    },
    canInviteTeamMember() {
      if (this.folder) {
        return this.folder.ownerId === this.currentUser.id ||
          (this.folder.permissions && this.folder.permissions.includes(constants.permissions.INVITE_TO_EDIT))
      }
      // return this.presentation.userId === this.currentUser.id ||
      return (this.presentation.permissions &&
            this.presentation.permissions.includes(constants.permissions.INVITE_TO_EDIT))
    },
  },
  async mounted() {
    setTimeout(() => {
      this.focusInviteeInput()
    }, 150)
    if (this.presentation) {
      await this.getCollaboratorList(this.presentation.id)
    } else if (this.folder) {
      await this.getFolderCollaboratorList(this.folder.folderId)
    }
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setFoldersAction']),
    onVerify(response) {
      this.tokenRecaptcha = response
      this.shareToEdit()
    },
    onRecaptchaError() {
      this.submitting = false
      this.textError = this.$i18nPresenter.t('Recaptcha error. If the problem still occurs, please check your internet connection.')
      Utils.showToastError(this.textError)
      this.$store.dispatch('setSyncPresentation', 3)
    },
    onSubmit() {
      if (this.submitting) return
      this.submitting = true
      const isQAUser = this.currentUser.email.match(/qa\.ahaslides\+(.*)@gmail.com/i)
      const canByPassRecaptcha = isQAUser || this.isZoomReady
      if (canByPassRecaptcha) {
        this.shareToEdit()
      } else {
        this.$refs.recaptcha.execute()
        Utils.removeRecaptchaCover()
      }
    },
    onExpired() {
      this.$refs.recaptcha.reset()
      this.tokenRecaptcha = ''
    },
    focusInviteeInput() {
      const input = document.getElementById('input-tag__share-to-edit').children[0]
      if (!input) return
      input.focus()
    },
    getOwner() {
      if (this.presentation) {
        return {
          ...this.presentation.User,
          role: 'owner',
        }
      }
      if (this.folder) {
        return {
          ...this.folder.User,
          role: 'owner',
        }
      }
    },
    async getCollaboratorList(presentationId) {
      this.loadingCollaborators = true
      const res = await PresentationApi.getCollaborators(presentationId)
      if (res.invitedUsers) {
        this.collaborators = res.invitedUsers
      }
      if (res.invitedAccounts) {
        this.teamCollaborators = res.invitedAccounts
        if (this.currentAccount.id) {
          const hasInviteYourTeam = res.invitedAccounts.filter((team) => team.accountId === this.currentAccount.id)
          if (hasInviteYourTeam.length < 1) {
            this.teams.push(this.currentAccount)
          }
        }
      }
      this.loadingCollaborators = false
    },
    async getFolderCollaboratorList(folderId) {
      this.loadingCollaborators = true
      const res = await FolderApi.getFolderCollaborators(folderId)
      if (res.invitedUsers) {
        this.collaborators = res.invitedUsers
      }
      if (res.invitedAccounts) {
        this.teamCollaborators = res.invitedAccounts
        if (this.currentAccount.id) {
          const hasInviteYourTeam = res.invitedAccounts.filter((team) => team.accountId === this.currentAccount.id)
          if (hasInviteYourTeam.length < 1) {
            this.teams.push(this.currentAccount)
          }
        }
      }
      this.loadingCollaborators = false
    },
    async shareToEdit() {
      if (!this.isInputTagHasValue && this.emails.length === 0) {
        Utils.showToastError(this.$i18nPresenter.t('Please enter member\'s email'))
        this.focusInviteeInput()
        this.$refs.recaptcha.reset()
        this.tokenRecaptcha = ''
        this.submitting = false
        return
      }
      const collaborators = this.emails.reduce((acc, value) => {
        if (!value.id) {
          acc.emails.push(value.name)
          return acc
        }
        acc.teams.push(value.id)
        return acc
      }, { emails: [], teams: [] })
      if (this.presentation) {
        const { email: ownerEmail } = this.getOwner(this.presentation)
        if (collaborators.emails.includes(ownerEmail)) {
          Utils.showToastError(this.$i18nPresenter.t('Cannot share this presentation to its owner'))
          this.$refs.recaptcha.reset()
          this.tokenRecaptcha = ''
          this.submitting = false
          return
        }
      } else if (this.folder) {
        const { email: ownerEmail } = this.getOwner(this.folder)
        if (collaborators.emails.includes(ownerEmail)) {
          Utils.showToastError(this.$i18nPresenter.t('Cannot share this folder to its owner'))
          this.$refs.recaptcha.reset()
          this.tokenRecaptcha = ''
          this.submitting = false
          return
        }
      }
      if (collaborators.emails.some((email) => !Utils.validateEmail(email))) {
        Utils.showToastError(this.$i18nPresenter.t('Some of the emails are invalid'))
        this.$refs.recaptcha.reset()
        this.tokenRecaptcha = ''
        this.submitting = false
        return
      }
      if (collaborators.emails.includes(this.currentUser.email)) {
        Utils.showToastError(this.$i18nPresenter.t('Cannot share this presentation to yourself'))
        this.$refs.recaptcha.reset()
        this.tokenRecaptcha = ''
        this.submitting = false
        return
      }
      let gaCategoryType = eventCategories.PRESENTATION_EDITOR
      if (this.$route.name === 'Presentations' || this.$route.name === 'FolderDetail') {
        gaCategoryType = eventCategories.PRESENTATION_LIST
      }

      this.submitting = true
      // Because we have 2 elements listen to the Enter key at the same time (the form & the input tag),
      // setTimeout a bit for waiting the input tag (emails) to be added after Enter pressed
      setTimeout(async () => {
        const button = this.$refs.shareToEditButton
        // focus button & blur input so the tag input does not expand
        // this is because the input has bigger width when focused
        if (button) button.$el.focus()
        if (this.presentation) this.addPresentationCollaborators(gaCategoryType, collaborators)
        else if (this.folder) this.addFolderCollaborators(gaCategoryType, collaborators)
      }, 1)
    },
    async addPresentationCollaborators(gaCategoryType, collaborators) {
      try {
        let presentationOwnerCurrentPlan = null
        if (this.presentation && this.presentation.User) {
          presentationOwnerCurrentPlan = this.presentation.User.plan
        }

        const trackingParmas = {
          plan: this.currentUser.plan,
          presentationId: this.presentation ? this.presentation.id : null,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
          presentationOwnerId: this.presentation.userId,
          presentationOwnerCurrentPlan,
          permissionGranted: Utils.capitalizeFirstLetter(this.invitedRole),
          isIndividualPermissionGrant: collaborators.emails.length > 0,
          isTeamPermissionGrant: collaborators.teams.length > 0,
        }
        Utils.mixpanelTracking(gaCategoryType, 'Presentation > Invite to edit > Submit', this.emails.join(','), null, trackingParmas)

        await PresentationApi.addCollaborators(this.presentation.id, {
          collaborators: collaborators.emails,
          accountIds: collaborators.teams,
          tokenRecaptcha: this.tokenRecaptcha,
          invitedRole: this.invitedRole,
        })

        this.teams = []

        await this.getCollaboratorList(this.presentation.id)
        if (!this.hasTeam) {
          // for the first time, invite all the existing collaborators
          this.$emit('prepareDataForInviteTeamModal', {
            toBeInvitedMembers: this.collaborators,
          })
        } else {
          // for subsequent times, invite only the newly added collaborators
          this.$emit('prepareDataForInviteTeamModal', {
            toBeInvitedMembers: this.collaborators.filter((i) => this.emails.includes(i.email)),
          })
        }

        const newPresentations = this.$store.state.presentations.map((presentation) => {
          if (!presentation.countShare && presentation.id === this.presentation.id) {
            presentation.countShare = 1
          }
          return presentation
        })
        this.setPresentationsAction(newPresentations)
        Utils.mixpanelTracking(gaCategoryType, 'Presentation > Invite to edit > Succeeded', this.emails.join(','), null, trackingParmas)
        Utils.showToastSuccess(`${this.$i18nPresenter.t('Collaborator(s) added successfully')}`)

        this.$refs['collaborators-input'].clearAllTags()
      } catch (e) {
        Sentry.captureException(e)
        Utils.mixpanelTracking(gaCategoryType, 'Presentation > Invite to edit > Failed')
        if (e.body && e.body.message) {
          Utils.showToastError(e.body.message)
        } else {
          Utils.showToastError(`${this.$i18nPresenter.t('Failed to add collaborator(s). Reload to try again.')}`)
        }
      } finally {
        this.emails = []
        this.submitting = false
        this.$refs.recaptcha.reset()
        this.tokenRecaptcha = ''
      }
    },
    async addFolderCollaborators(gaCategoryType, collaborators) {
      try {
        let folderOwnerCurrentPlan = null
        if (this.folder && this.folder.User) {
          folderOwnerCurrentPlan = this.folder.User.plan
        }

        const trackingParmas = {
          plan: this.currentUser.plan,
          folderId: this.folder ? this.folder.folderId : null,
          userId: this.currentUser.id,
          isFolderOwner: this.folder.userId === this.currentUser.id,
          folderOwnerId: this.folder.userId,
          folderOwnerCurrentPlan,
          permissionGranted: Utils.capitalizeFirstLetter(this.invitedRole),
          isIndividualPermissionGrant: collaborators.emails.length > 0,
          isTeamPermissionGrant: collaborators.teams.length > 0,
        }

        Utils.mixpanelTracking(gaCategoryType, 'Folder > Invite to edit > Submit', this.emails.join(','), null, trackingParmas)

        await FolderApi.addFolderCollaborators(this.folder.folderId, {
          collaborators: collaborators.emails,
          accountIds: collaborators.teams,
          tokenRecaptcha: this.tokenRecaptcha,
          invitedRole: this.invitedRole,
        })
        this.teams = []

        await this.getFolderCollaboratorList(this.folder.folderId)

        const newFolders = this.$store.state.folders.map((folder) => {
          if (!folder.countShareIndividual && !folder.countShareTeam && folder.folderId === this.folder.folderId) {
            folder.countShareIndividual = 1
          }
          return folder
        })
        this.setFoldersAction(newFolders)

        Utils.mixpanelTracking(gaCategoryType, 'Folder > Invite to edit > Succeeded', this.emails.join(','), null, trackingParmas)
        Utils.showToastSuccess(`${this.$i18nPresenter.t('Collaborator(s) added successfully')}`)

        this.$refs['collaborators-input'].clearAllTags()
      } catch (e) {
        Sentry.captureException(e)
        Utils.mixpanelTracking(gaCategoryType, 'Folder > Invite to edit > Failed')
        if (e.body && e.body.message) {
          Utils.showToastError(e.body.message)
        } else {
          Utils.showToastError(`${this.$i18nPresenter.t('Failed to add collaborator(s). Reload to try again.')}`)
        }
      } finally {
        this.emails = []
        this.submitting = false
        this.$refs.recaptcha.reset()
        this.tokenRecaptcha = ''
      }
    },
    async handleRemoveCollaborator(collaboratorToDelete, type) {
      let gaCategoryType = eventCategories.PRESENTATION_EDITOR
      if (this.$route.name === 'Presentations' || this.$route.name === 'FolderDetail') {
        gaCategoryType = eventCategories.PRESENTATION_LIST
      }
      if (this.presentation) this.removeCollaborator(collaboratorToDelete, type, gaCategoryType)
      else if (this.folder) this.removeFolderCollaborator(collaboratorToDelete, type, gaCategoryType)
    },
    async removeCollaborator(collaboratorToDelete, type, gaCategoryType) {
      try {
        const params = {
          collaborators: [],
          accountIds: [],
        }
        if (collaboratorToDelete.email) params.collaborators.push(collaboratorToDelete.email)
        else if (collaboratorToDelete.accountId) params.accountIds.push(collaboratorToDelete.accountId)
        if (type === 'remove') {
          await PresentationApi.removeCollaborators(this.presentation.id, params)
        } else {
          await PresentationApi.leaveCollaborators(this.presentation.id, params)

          this.$store.dispatch(
            'setPresentationsAction',
            this.$store.state.presentations.filter((p) => p.id !== this.presentation.id),
          )
        }
        this.updateListCollaborator(collaboratorToDelete)

        if (this.collaborators.length < 2 && this.teamCollaborators.length < 1) {
          const newPresentations = this.$store.state.presentations.map((presentation) => {
            if (presentation.id === this.presentation.id) {
              presentation.countShare = 0
            }
            return presentation
          })
          this.setPresentationsAction(newPresentations)
        }
        Utils.mixpanelTracking(gaCategoryType, 'Presentation > Remove collaborator > Succeeded')
        if (collaboratorToDelete.email !== this.currentUser.email) {
          Utils.showToastSuccess(`${this.$i18nPresenter.t('Successfully remove')} ${collaboratorToDelete.email} ${this.$i18nPresenter.t('from editing this presentation.')}`)
        } else {
          Utils.showToastSuccess(this.$i18nPresenter.t('Left this presentation successfully.'))
        }

        // If the user remove himselft from collaborators list -> Redirect him to Presentation List
        if (collaboratorToDelete.email === this.currentUser.email) {
          if (this.$route.name === 'PresentationDetail') {
            this.$router.replace({
              name: 'Presentations',
            })
          } else {
            EventBus.$emit('reload-presentations-and-folders')
          }
        }
      } catch (e) {
        Sentry.captureException(e)
        Utils.mixpanelTracking(gaCategoryType, 'Presentation > Remove collaborator > Failed')
        Utils.showToastError(`${this.$i18nPresenter.t('Fail to remove')} ${collaboratorToDelete.email} ${this.$i18nPresenter.t('from editing this presentation.')}`)
      }
    },
    async removeFolderCollaborator(collaboratorToDelete, type, gaCategoryType) {
      try {
        const params = {
          collaborators: [],
          accountIds: [],
        }
        if (collaboratorToDelete.email) params.collaborators.push(collaboratorToDelete.email)
        else if (collaboratorToDelete.accountId) params.accountIds.push(collaboratorToDelete.accountId)
        if (type === 'remove') {
          await FolderApi.removeFolderCollaborators(this.folder.folderId, params)
        } else {
          await FolderApi.leaveFolderCollaborators(this.folder.folderId, params)
          this.$store.dispatch(
            'setFoldersAction',
            this.$store.state.folders.filter((f) => f.folderId !== this.folder.folderId),
          )
        }
        this.updateListCollaborator(collaboratorToDelete)

        if (this.collaborators.length < 2 && this.teamCollaborators.length < 1) {
          const newFolders = this.$store.state.folders.map((folder) => {
            if (folder.folderId === this.folder.folderId) {
              folder.countShareIndividual = 0
              folder.countShareTeam = 0
            }
            return folder
          })
          this.setFoldersAction(newFolders)
        }
        Utils.showToastSuccess(`${this.$i18nPresenter.t('Successfully remove')} ${collaboratorToDelete.email} ${this.$i18nPresenter.t('from editing this folder.')}`)
        Utils.mixpanelTracking(gaCategoryType, 'Folder > Remove collaborator > Succeeded')
      } catch (e) {
        Sentry.captureException(e)
        Utils.showToastError(`${this.$i18nPresenter.t('Fail to remove')} ${collaboratorToDelete.email} ${this.$i18nPresenter.t('from editing this folder.')}`)
        Utils.mixpanelTracking(gaCategoryType, 'Folder > Remove collaborator > Failed')
      }
    },

    updateListCollaborator(collaboratorToDelete) {
      if (collaboratorToDelete.email) {
        this.collaborators = this.collaborators
          .filter((collaborator) => collaborator.email !== collaboratorToDelete.email)
      } else if (collaboratorToDelete.accountId) {
        this.teamCollaborators = this.teamCollaborators
          .filter((collaborator) => collaborator.accountId !== collaboratorToDelete.accountId)
      }
    },

    async handleChangeCollaboratorRole(collaborator, role) {
      let type
      let checkCanChangeRole = false
      if (this.folder) {
        if (collaborator.folderId === this.folder.folderId && (
          this.folder.ownerId === this.currentUser.id ||
          (this.folder.permissions && this.folder.permissions.includes(this.permissions.INVITE_TO_EDIT))
        )) {
          checkCanChangeRole = true
        }
        type = 'Folder'
      } else if (this.presentation) {
        if (collaborator.presentationId === this.presentation.id && (
          // this.presentation.userId === this.currentUser.id ||
          (this.presentation.permissions && this.presentation.permissions.includes(this.permissions.INVITE_TO_EDIT))
        )) {
          checkCanChangeRole = true
        }
        type = 'Presentation'
      }
      if (!checkCanChangeRole) {
        Utils.showToastError('Cannot change Role')
        return
      }
      let gaCategoryType = eventCategories.PRESENTATION_EDITOR
      if (this.$route.name === 'Presentations' || this.$route.name === 'FolderDetail') {
        gaCategoryType = eventCategories.PRESENTATION_LIST
      }
      try {
        const params = {
          userId: collaborator.id,
          email: collaborator.email,
          roleName: role,
        }
        const action = this.presentation ?
          PresentationApi.changePresentationCollaboratorRole(this.presentation.id, params) :
          FolderApi.changeFolderCollaboratorRole(this.folder.folderId, params)
        await action

        this.collaborators = this.collaborators.map((value) => {
          if (collaborator === value) {
            value.role = role
          }
          return value
        })

        Utils.mixpanelTracking(gaCategoryType, `${type} > Change collaborator Role > Succeeded`)
        Utils.showToastSuccess(this.$i18nPresenter.t('Role updated'))
      } catch (e) {
        Sentry.captureException(e)
        Utils.mixpanelTracking(gaCategoryType, `${type} > Change collaborator Role > Failed`)
        Utils.showToastError(`${this.$i18nPresenter.t('Fail to update')} ${collaborator.email}`)
      }
    },

    handleBackButtonClick() {
      this.showTeamMemberList = false
      this.$emit('handle-hide-main-header')
    },

    handleShowShareToEditList() {
      if (this.canInviteTeamMember) {
        this.$emit('handleShowShareToEditList')
      }
    },
    changeInvitedRole(value) {
      this.$emit('changeInvitedRole', value)
    },
  },
}
</script>

<style lang="scss" scoped>

.share__section-title {
  @apply mb-3 text-sm font-bold text-secondary-100;
}

.share-input-tag-wrp {
  width: 90%;
  position: relative;
}

.share__section-description {
  @apply mb-3 text-xs;
}
.share__presentation-online-link {
  @apply mb-3;
}
@media (max-width: 580px) {
}

</style>

<style>
#input-tag__share-to-edit:hover, #input-tag__share-to-edit.\--focused {
  background-color: #fff;
}
</style>
